import {useEffect, useState} from "react";
import { useAtom } from 'jotai';
import { categoriesAtom, departmentsAtom, selectedDepartmentsAtom, matchingClientsAtom } from '../../jotai_state';
import {CategoryInterface, DepartmentInterface} from "../../interfaces.ts";
import Checkbox from "../../components/Checkbox/Checkbox.tsx"
import {Close, AngleDown, AngleUp, AngleRight} from "flowbite-react-icons/outline";


export default function FilterClients() {
  const [categories, setCategories] = useAtom(categoriesAtom);
  const [departments, setDepartments] = useAtom(departmentsAtom);
  const [selectedDepartments, setSelectedDepartments] = useAtom(selectedDepartmentsAtom);
  const [matchingClients] = useAtom(matchingClientsAtom);
  const [open, setOpen] = useState(false);

  const editTag = (tagId: string, selected: boolean) => {
    const _categories: Array<CategoryInterface> = [];
    for (const category of categories) {
      for (const tag of category.tags) {
        if (tag.id === tagId) {
          tag.selected = selected;
        }
      }
      _categories.push(category);
    }
    setCategories(_categories);
  }

  const showSelections = () => {
    const filters = [];
    for (const category of categories) {
      let count = 0;
      for (const tag of category.tags) {
        if (tag.selected) {
          count++;
        }
      }
      if (count > 0) {
        filters.push(count + " " + category.name + "s")
      }
    }
    if (selectedDepartments.length > 0) {
      if (selectedDepartments.length < departments.length) {
        filters.push(selectedDepartments.length + " departments")
      } else {
        filters.push("All departments");
      }

    }

    if (filters.length > 0) {
      return (
        <>
          {
            filters.map((filter, i) => (
              <span className="mr-1" key={"filter_" + i}>{filter}</span>
            ))
          }
        </>
      )
    } else {
      return <span>Whole organisation</span>;
    }
  }

  const selectDepartment = (department: DepartmentInterface, checked: boolean) => {
    const _departments = [...departments];

    let selectSiblings = false;
    for (const _department of _departments) {
      if (department.id === _department.id) {
        _department.selected = checked;
        selectSiblings = true;
      } else if (selectSiblings) {
        if (_department.level > department.level) {
          _department.selected = checked;
        } else {
          break;
        }
      }
    }
    setDepartments(_departments);

    const _selectedDepartments = [];
    for (const _department of _departments) {
      if (_department.selected) {
        _selectedDepartments.push(_department.id);
      }
    }
    setSelectedDepartments(_selectedDepartments);
  }

  const expandDepartment = (department: DepartmentInterface) => {
    const _departments = [...departments];
    const expanded = !department.expanded;

    for (const _department of departments) {
      if (department.id === _department.id) {
        _department.expanded = expanded;
      }

    }
    setDepartments(_departments);
  }

  const showSelectDepartments = () => {
    const openLevels = [true, true, false, false, false, false, false];

    return (
      <div className="mt-4">
        <div className="z-title1">Departments</div>
        {
          departments.map(department => {
            let clsName = "z-dep-" + department.level;
            // updateOpenLevels(department, openLevels);
            openLevels[department.level] = department.expanded;
            for (let i = 1; i < department.level; i++) {
              if (!openLevels[i]) return;
            }

            return (
              <div key={"dep_" + department.id} className="mt-2">
                <div className={"flex gap-x-1 items-center " + clsName}>
                  {
                    department.siblings > 0 ? (
                      <div className="cursor-pointer" onClick={() => expandDepartment(department)}>
                        {
                          department.expanded ? (
                            <AngleDown className="h-4 w-4"/>
                          ) : (
                            <AngleRight className="h-4 w-4"/>
                          )
                        }
                      </div>
                      ) : (
                        <div className="w-4">&nbsp;</div>
                      )
                  }

                  <Checkbox id={department.id} checked={department.selected}
                            label={department.name + " (" + department.clients.length + ")"}
                            onChange={(checked) => selectDepartment(department, checked)}/>
                </div>
              </div>
            )
          })
        }

      </div>
    )
  }

  return (
    <>
      <>
        <div className="flex items-center py-6 px-8">

          <div className="flex gap-x-4">
            <div>{matchingClients} people</div>
            {showSelections()}
          </div>
          <div onClick={() => setOpen(!open)}
               className="px-2 flex items-center gap-x-1 cursor-pointer">
            {
              open ? (
                <AngleUp className="inline-block h-4 w-4"/>
              ) : (
                <AngleDown className="inline-block h-4 w-4"/>
              )
            }
            <div>Filter</div>
          </div>
        </div>

        <hr className="z-hr"/>
      </>
      {
        open &&
          <>
              <div className="px-8 py-4 bg-gray-100">
                  <div className="z-title3">Filter clients by:</div>
                {
                  categories.map((category) => (
                    <div key={"category_" + category.id} className="my-2">
                      <select className="z-select mt-2" value=""
                              onChange={(e) => editTag(e.target.value, true)}>
                        <option value={0}>{category.name}</option>
                        {
                          category.tags.map((tag, i) => (
                            <option key={"tag_" + tag.id} value={tag.id}>
                              {tag.name}
                            </option>
                          ))
                        }
                      </select>
                      <div>
                        {
                          category.tags.filter(tag => tag.selected).map((tag) => (
                            <div key={"stag_" + tag.id}
                                 className="inline-block mr-2 mt-2 bg-gray-200 py-1 px-2 rounded-md">
                              <div className="text-xs inline-block">{tag.name}</div>
                              <Close className="inline-block h-4 w-4 cursor-pointer hover:bg-gray-300 rounded-full"
                                     onClick={() => editTag(tag.id, false)}/>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  ))
                }
                {
                  departments.length > 0 &&
                  showSelectDepartments()
                }
              </div>
              <hr className="z-hr"/>
          </>
      }
    </>
  )
}